import script from "./DataSoilTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataSoilTable.vue?vue&type=script&setup=true&lang=ts"

import "./DataSoilTable.vue?vue&type=style&index=0&id=58c4e66c&lang=sass"

const __exports__ = script;

export default __exports__